import { render } from "./index.vue?vue&type=template&id=e23175c4&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=e23175c4&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-e23175c4"

export default script